export enum Day {
  Mon = "mon",
  Tue = "tue",
  Wed = "wed",
  Thu = "thu",
  Fri = "fri",
  Sat = "sat",
  Sun = "sun",
}

export type Time = string;
export type Period = { from: Time; to: Time; breakTime?: Time };
export type TimeRosterGroup = { days: Day[]; periods: Period[] };
export type TimeRoster = { days: Day[]; periods: Period[] }[];

export function diff(value1: string, value2: string): string {
  const v1 = getMinutes(value1);
  const v2 = getMinutes(value2);

  if (v1 <= v2) {
    return `${Math.floor((v2 - v1) / 60)}:${(v2 - v1) % 60}`;
  } else {
    return `${Math.floor((24 * 60 - v1 + v2) / 60)}:${(23 * 60 - v1 + v2) % 60}`;
  }
}

export function add(...values: string[]) {
  const totalMinutes = values.map(v => getMinutes(v)).reduce((sum, v) => sum + v, 0);

  return `${Math.floor(totalMinutes / 60)}:${totalMinutes % 60}`;
}
export function sub(value1:string, value2:string){
  const totalMinutes =  getMinutes(value1) - getMinutes(value2 || "00:00");

  return `${Math.floor(totalMinutes / 60)}:${totalMinutes % 60}`;
}

export function multiply(time: string, value: number) : string {
  const totalMinutes = getMinutes(time) * value;

  return `${Math.floor(totalMinutes / 60)}:${totalMinutes % 60}`;
}

export function getMinutes(v: string) {
  const match = v && v.match(/^([0-9]{1,2}):([0-9]{1,2})$/);

  if (match) {
    const h = parseInt(match[1]);
    const m = parseInt(match[2]);
    return h * 60 + m;
  }
  return 0;
}
